import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { i18n } from "../../translate/i18n";

export default function ContactNotesEditModal({ open, onClose, note, onSave }) {
  const [editedNote, setEditedNote] = useState(note);

  useEffect(() => {
    setEditedNote(note);
  }, [note, open]);

  const handleSave = () => {
    onSave(editedNote); // Chama a função onSave com a nota editada
    onClose(); // Fecha o diálogo de edição
  };

  return (
    <Dialog open={open} onClose={onClose} 
    maxWidth="xs"
    fullWidth
    >
      <DialogTitle>{i18n.t("contactNotesEditModal.title")}</DialogTitle>
      <DialogContent>
        <TextField
          label={i18n.t("contactNotesEditModal.fields.note")}
          fullWidth
          multiline
          rows={4}
          value={editedNote}
          onChange={(e) => setEditedNote(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {i18n.t("common.cancel")}
        </Button>
        <Button onClick={handleSave} color="primary">
          {i18n.t("common.save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
